// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wuw0","type":"styles_type__2k7ID","choices":"styles_choices__2AuN4"};